export default {
  namespaced: true,

  state: () => ({
    clickInteraction: true,
    clientItems: [
      {
        to: '/portal',
        icon: 'home',
        text: 'Dashboard',
      },
      {
        to: '/portal/my-details',
        icon: 'person',
        text: 'About Me',
      },
      {
        to: '/portal/conversations',
        icon: 'chat',
        text: 'Conversations',
      },
      {
        to: '/portal/documents',
        icon: 'folder',
        text: 'Documents',
      },
      {
        to: '/portal/my-tasks',
        icon: 'square-tick',
        text: 'My Tasks',
      },
      {
        to: '/portal/my-wealth',
        icon: 'bar-chart',
        text: 'My Wealth',
      },
    ],
    breadcrumbs: [],
  }),

  actions: {
    clearBreadcrumbs({ commit }) {
      commit('CLEAR_BREADCRUMBS');
    },
    addBreadcrumb({ commit, state }, breadcrumb) {
      commit('SET_BREADCRUMBS', [...state.breadcrumbs, breadcrumb]);
    },
    setBreadcrumbs({ commit, state }, breadcrumbs) {
      commit('SET_BREADCRUMBS', breadcrumbs);
    },
  },

  mutations: {
    CLEAR_BREADCRUMBS(state) {
      state.breadcrumbs = [];
    },
    SET_BREADCRUMBS(state, breadcrumbs) {
      state.breadcrumbs = breadcrumbs;
    },
  },
};
